import React, { Component } from 'react';
import apiDown from '../assets/Images/api-down.png';

class DuplicateRequest extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className="main-content">
        <div className="ccpa-wrapper">
          <div className="component-section">
            <div className ="max-width-24 position-center margin-center">
              <img src={apiDown} className="margin-bottom-2 position-center" alt="api-down" /> 
              <p className="margin-top-1 font-size-14 text-bold">
                Sorry, this is a {this.props.duplicateRequestMsg}! We are processing an earlier request that was submitted with the same information. We will provide an update on your original request when it is complete or we will contact you if we need any additional information.
                <div>For further assistance you can reach us at privacypolicy@7-11.com</div>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DuplicateRequest;
